import { trpc } from '@/shared/api';

export const useMyReviewQuery = (reviewId: string, options: { readonly enabled?: boolean } = {}) =>
  trpc.myReviews.get.useQuery({ reviewId }, { enabled: options.enabled ?? true });
